































































































































































































































import Vue, { PropType } from 'vue';
import WidgetWrapper from '@/components/widgets/WidgetWrapper.vue';
// TODO: Отключено на время
// import FieldCheckbox from '@/components/form/FieldCheckbox.vue';
// import ContextualTarget from '@/components/campaign/targets/settingsTarget/ContextualTarget.vue';
import FieldMultipleSelect from '@/components/form/FieldMultipleSelect.vue';
import { DeviceTargetsData } from '@/types/campaign/targets';
// import { DropdownList } from '@/types';
import { mapGetters } from 'vuex';
// import FieldInput from '@/components/form/FieldInput.vue';

export default Vue.extend({
  name: 'TheDeviceTargets',
  components: {
    WidgetWrapper,
    // TODO: Отключено на время
    // FieldCheckbox,
    // ContextualTarget,
    FieldMultipleSelect,
    // FieldInput,
  },

  props: {
    data: {
      type: Object as PropType<DeviceTargetsData>,
      required: true,
    },
  },

  watch: {
    data(newValue) {
      this.campaign = newValue; 
    },
  },

  computed: {
    ...mapGetters({
      langs: 'langList',
      os: 'osList',
      deviceTypes: 'deviceTypeList',
    }),

  },

  methods: {
    change(name, value) {
      this.changeCampaign(name, value);
    },
    changeCampaign(name, value) {
      this.$emit('changeCampaign', name, value);
    },
    changeChecked(checked) {
      this.change('is_device_targets', checked);
    },
    changeContextualChecked(value) {
      this.campaign.contextual_analysis = value;
      this.change('contextual_analysis', this.campaign.contextual_analysis);
    },

    // TODO: Отключено на время
    // changeContextualKeywords(value) {
    //   this.campaign.keywords = value;
    //   this.change('keywords', this.campaign.keywords);
    // },
    // removeCookieMatchTargets(index) {
    //   if (this.campaign) {
    //     this.campaign.user_targets.splice(index, 1);
    //   }
    // },
    // getNameLanguage(value) {
    //   const lang = this.dropLists.langs.find((item) => item.value === value);
    //   if (lang) {
    //     return lang.label;
    //   }
    // },
    // removeLangTargets(index) {
    //   if (this.campaign) {
    //     this.campaign.languages.splice(index, 1);
    //   }
    // },
    // getNameOs(value) {
    //   const os = this.dropLists.os.find((item) => item.value === value);
    //   if (os) {
    //     return os.label;
    //   }
    // },
    // removeOsTargets(index) {
    //   if (this.campaign) {
    //     this.campaign.os.splice(index, 1);
    //   }
    // },
    // getDeviceType(value) {
    //   const deviceType = this.dropLists.deviceTypes.find(
    //     (item) => item.value === value
    //   );
    //   if (deviceType) {
    //     return deviceType.label;
    //   }
    // },
    // removeDeviceType(index) {
    //   if (this.campaign) {
    //     this.campaign.device_types.splice(index, 1);
    //   }
    // },
  },

  data() {
    return {
      campaign: this.data,

      // TODO: Отключено на время
      // userFactorTypes: [
      //   {
      //     label: 'Visited',
      //     value: 'visited',
      //   },
      //   {
      //     label: 'Interested',
      //     value: 'interested',
      //   },
      //   {
      //     label: 'Bought',
      //     value: 'bought',
      //   },
      // ] as Array<DropdownList>,
    };
  },
});
